import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {

  async getReceitas ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `${modulo.FINANCEIRO}/receitas/tipoReceita`
    })

    return data
  },

  async getTipoReceita ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${modulo.FINANCEIRO}/receitas/porTipoReceita`,
      params: {
        id
      }
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/financeiro/receitas.js